import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { FaWhatsapp  } from "react-icons/fa";

import img1 from "../assets/Round.jpg";
import img2 from "../assets/rectangle.jpg";
import img3 from "../assets/acrylic.jpg";
import img4 from "../assets/redchair.jpg";
import img5 from "../assets/stage.jpeg";
import img6 from "../assets/trussbox.webp";
import img7 from "../assets/TLighting.webp";
import img8 from "../assets/sound.jpg";
import img9 from "../assets/Popcorn.jpg";
import img10 from "../assets/ice.jpg";
import img11 from "../assets/Coconut.jpg";
import img12 from "../assets/candy.jpg";
import img13 from "../assets/Cotton.jpg";
import img14 from "../assets/Karak.jpg";



function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

function FlipCard({ image, title, subtitle, description, rotate = "y" }) {
  const controls = useAnimation();
  const [ref, inView] = useInView({ threshold: 0.2 });

  useEffect(() => {
    controls.start({
      opacity: inView ? 1 : 0,
      y: inView ? 0 : 50,
      transition: { duration: 0.5, ease: "easeOut" },
    });
  }, [controls, inView]);

  const rotationClass = {
    y: [
      "group-hover:[transform:rotateY(180deg)]",
      "[transform:rotateY(180deg)]",
    ],
  };
  const self = rotationClass[rotate];

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 50 }}
      animate={controls}
      className="w-full flex justify-center"
    >
      <div className={cn("group h-80 w-full max-w-xs [perspective:1000px]")}>
        <div
          className={cn(
            "relative h-full transition-all duration-500 rounded-2xl [transform-style:preserve-3d]",
            self[0]
          )}
        >
          {/* Front */}
          <div className="absolute h-full w-full [backface-visibility:hidden]">
            <img
              src={image}
              alt={title}
              className="w-full h-full object-cover rounded-2xl shadow-2xl shadow-black/40"
            />
            <div className="absolute bottom-4 left-4 bg-black/60 text-white px-3 py-1 rounded-md text-xl font-bold drop-shadow-md">
              {title}
            </div>
          </div>

          {/* Back */}
          <div
            className={cn(
              "absolute h-full w-full rounded-2xl bg-black/80 p-4 text-white [backface-visibility:hidden]",
              self[1]
            )}
          >
           <div className="flex h-full flex-col justify-center items-center gap-3 text-center">
  <h1 className="text-xl font-bold">{subtitle}</h1>
  <p className="mt-2 border-t border-gray-500 pt-2 text-sm text-gray-200">
    {description}
  </p>
  <a
    href="https://wa.me/96895566512"
    target="_blank"
    rel="noopener noreferrer"
    className="mt-4 flex items-center gap-2 text-white hover:text-green-400 transition-colors duration-300"
  >
    <FaWhatsapp className="w-6 h-6" />
    <span className="text-sm font-semibold">WhatsApp</span>
  </a>
</div>

          </div>
        </div>
      </div>
    </motion.div>
  );
}

// StaticCard (Mobile)
function StaticCard({ image, title, subtitle, description }) {
  return (
   <div className="w-full max-w-xs mx-auto rounded-2xl overflow-hidden bg-black/80 text-white shadow-lg">
  {/* ✅ Image is here */}
  <img
    src={image}
    alt={title}
    className="w-full h-48 object-cover"
  />

  {/* ✅ Content below */}
  <div className="p-4 text-center">
    <h3 className="text-xl font-bold">{title}</h3>
    <p className="text-sm mt-1 text-purple-300">{subtitle}</p>
    <p className="text-sm mt-2 text-gray-300">{description}</p>
    <a
      href="https://wa.me/96895566512"
      target="_blank"
      rel="noopener noreferrer"
      className="mt-4 inline-flex items-center gap-2 text-white hover:text-green-400 transition-colors duration-300"
    >
      <FaWhatsapp className="w-5 h-5" />
      <span className="text-sm font-semibold">WhatsApp</span>
    </a>
  </div>
</div>

  );
}

// Main Component
export default function FlipCards() {
  const cards = [
    {
      image: img1,
      title: "Round table",
      subtitle: "6 RO",
      description: "Perfect for all weddings.",
    },
    {
      image: img2,
      title: "Rectangle table",
      subtitle: "6 RO",
      description: "Spacious and classy.",
    },
    {
      image: img3,
      title: "Acrylic Chair",
      subtitle: "2 RO",
      description: "Modern transparent chairs.",
    },
    {
      image: img4,
      title: "Red Chair",
      subtitle: "1.5 RO",
      description: "Elegant seating solution.",
    },
    {
      image: img5,
      title: "Stage 6x3",
      subtitle: "340 RO",
      description: "Big stage setup for concerts.",
    },
    {
      image: img6,
      title: "Truss box 7x5",
      subtitle: "930 RO",
      description: "Sturdy truss system.",
    },
    {
      image: img7,
      title: "T light 3x2",
      subtitle: "140 RO",
      description: "Event spot lighting.",
    },
    {
      image: img8,
      title: "Sound system",
      subtitle: "180 RO",
      description: "High-quality sound setup.",
    },
     {
      image: img9,
      title: "Popcorn ",
      subtitle: "65 RO",
      description: "Serves 70 people.",
    },
     {
      image: img10,
      title: "Ice cream cart",
      subtitle: "130 RO",
      description: "Serves 70 people.",
    },
     {
      image: img11,
      title: "Coconut cart",
      subtitle: "130 RO",
      description: "Serves 70 people.",
    },
     {
      image: img12,
      title: "Candy cart ",
      subtitle: "75 RO",
      description: "Serves 70 people.",
    },
     {
      image: img13,
      title: "Cotton candy cart",
      subtitle: "55 RO",
      description: "Serves 70 people.",
    },
     {
      image: img14,
      title: "Karak cart",
      subtitle: "90 RO",
      description: "Serves 70 people.",
    },
  ];

  return (
    <div className="mt-32 min-h-screen px-4 sm:px-6 lg:px-16 py-16 flex flex-col items-center justify-center">
      <h2 className="text-5xl  font-bebas text-black text-center mb-12 drop-shadow-lg uppercase">
        Event Rentals Category
      </h2>

      {/* Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 w-full max-w-screen-xl mx-auto justify-items-center">
        {cards.map((card, index) => (
          <div key={index} className="w-full flex justify-center">
            {/* Static for mobile */}
            <div className="block md:hidden w-full">
              <StaticCard {...card} />
            </div>
            {/* Flip for desktop */}
            <div className="hidden md:block w-full">
              <FlipCard {...card} rotate="y" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
